import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $('#complete_payment_via_emailed_invoice_stripe').each(function(i, elem) {
      const stripeKey = $(elem).data('stripe-publishable-key');
      const stripe = Stripe(stripeKey);
      const elements = stripe.elements();
      let cardErrorsElem = $(elem).find('#card_errors');
      const card = elements.create('card');
      card.mount($(elem).find('#card_element').selector);
      card.addEventListener('change', function(e) {
        cardErrorsElem = $(elem).find('#card_errors');
        if (e.error) {
          cardErrorsElem.text(e.error.message);
        } else {
          cardErrorsElem.text('');
        }
      });

      elem.addEventListener('submit', function(e) {
        e.preventDefault();
        stripe.createToken(card).then(function(res) {
          if (res.error) {
            cardErrorsElem.text(res.error.message);
            $('input[type="submit"]').removeAttr('disabled');
          } else {
            $(elem).append($('<input>', {
              type: 'hidden',
              name: 'payment_source[stripe_token_id]',
              value: res.token.id
            }), $('<input>', {
              type: 'hidden',
              name: 'payment_source[kind]',
              value: 'card'
            }), $('<input>', {
              type: 'hidden',
              name: 'payment_source[stripe_source_id]',
              value: res.token.card.id
            }), $('<input>', {
              type: 'hidden',
              name: 'payment_source[last4]',
              value: res.token.card.last4
            }), $('<input>', {
              type: 'hidden',
              name: 'payment_source[brand]',
              value: res.token.card.brand
            }));
            elem.submit();
          }
        });
      });
    });
  }

}
